<div class="d-flex flex-row" [attr.data-testid]="uid">
    <img class="fs-img align-self-center" [src]="icon | safe: securityContext.URL" alt="{{ federalState }}" />
    <div class="text-truncate overflow-hidden text-nowrap"><span>{{ l(federalState) }}</span></div>
</div>
